import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Icon from 'components/Icon';

import css from './Link.module.scss';

class Link extends React.PureComponent {
    static propTypes = {
        className: PropTypes.string,
        children: PropTypes.string.isRequired,
        icon: PropTypes.string,
        download: PropTypes.bool,
        href: PropTypes.string.isRequired,
        target: PropTypes.oneOf([
            "_blank"
        ]),
    }

    render() {
        const {
            className,
            children,
            icon,
            href,
            target,
            download,
        } = this.props;

        return (
            <span className={cn(css.link, className)}>
                {icon && (
                    <Icon className={css.icon} icon={icon} />
                )}
                <a
                    href={href}
                    target={target}
                    download={download}
                    rel={target === "_blank" && "noopener noreferrer"}
                >{children}</a>
            </span>
        );
    }
}

export default Link;



// WEBPACK FOOTER //
// ./src/components/Link/Link.jsx